import { MESH_H, MESH_W, meshLinks, type MeshNode } from "@/components/site/mesh-geometry";

/** Pure SVG drawing of the mesh; used for the static poster and each animation frame. */
export function MeshSvg({
  nodes,
  linkDistance,
  variant,
  className,
  gradientId,
}: {
  nodes: MeshNode[];
  linkDistance: number;
  variant: "light" | "dark";
  className?: string;
  gradientId: string;
}) {
  const links = meshLinks(nodes, linkDistance);
  return (
    <svg className={className} viewBox={`0 0 ${MESH_W} ${MESH_H}`} preserveAspectRatio="xMidYMid slice" aria-hidden="true">
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#FF2D78" />
          <stop offset="50%" stopColor={variant === "dark" ? "#FFFFFF" : "#9d8df0"} />
          <stop offset="100%" stopColor="#6B5BF5" />
        </linearGradient>
      </defs>
      <g stroke={`url(#${gradientId})`} strokeWidth="0.06">
        {links.map((l, i) => (
          <line key={i} x1={l.x1} y1={l.y1} x2={l.x2} y2={l.y2} opacity={l.o * (variant === "dark" ? 0.7 : 0.5)} />
        ))}
      </g>
      <g fill={`url(#${gradientId})`}>
        {nodes.map((n, i) => (
          <circle key={i} cx={n.x} cy={n.y} r={n.r} opacity={variant === "dark" ? 0.95 : 0.85} />
        ))}
      </g>
    </svg>
  );
}
